<div class="flex flex-col gap-4 md:gap-6 lg:gap-8" data-test-id="tab-menu">
	<div
		class="mb-px flex flex-row justify-between border-b-2 border-ui-200 sm:justify-start"
	>
		@for (tab of tabMenuItems; track $index) {
			<a
				[attr.data-test-class]="
					activeTab === $index ? 'active' : 'inactive'
				"
				[attr.data-test-id]="tab.name"
				[ngClass]="{
					'border-accent-100 opacity-100': activeTab === $index,
					'opacity-75': activeTab !== $index,
				}"
				(click)="setActiveTab($index)"
				class="btn btn-text -mb-0.5 w-full rounded-none border-b-2 px-4 text-base outline-0 hover:border-accent-100 hover:opacity-100 sm:text-lg md:w-auto md:px-5"
			>
				{{ tab.label }}
			</a>
		}
	</div>
	@if (tabMenuItems.get(activeTab)?.content) {
		<ng-container *ngTemplateOutlet="tabMenuItems.get(activeTab).content" />
	}
</div>
